import React from 'react';
import styled from 'styled-components';
import ProjectImg from '../assets/images/projectImg.png';

const ProjectItemStyle = styled.div`
  cursor: pointer;
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
  }
  
  .project-item-img {
    width: 100%;
    height: 400px;
    overflow: hidden;
    border-radius: 12px;
    display: inline-block;
    border: 3px solid var(--gray-2);
    transition: border-color 0.3s ease;
    img {
      height: 100%;
      transition: transform 0.3s ease;
    }
    
    &:hover {
      border-color: var(--primary);
      
      img {
        transform: scale(1.05);
      }
    }
  }
  .project-item-info {
    margin-top: 1rem;
    background-color: var(--deep-dark);
    padding: 1rem;
    border-radius: 12px;
  }
  .project-item-title {
    font-size: 2.2rem;
    color: var(--primary);
  }
  .project-item-desc {
    font-size: 1.6rem;
    font-family: Futura, 'Trebuchet MS', Arial, sans-serif;
    margin-top: 1rem;
  }
  .project-link {
    font-size: 1.5rem;
    margin-top: 2rem;
    color: var(--primary);
    font-family: Futura, 'Trebuchet MS', Arial, sans-serif;
  }
  @media only screen and (max-width: 768px) {
    .project-item-img {
      height: 350px;
    }
  }
`;

function ProjectItem({
  img = ProjectImg,
  title = 'Project Name',
  desc = 'project description',
  link = 'project link',
  onClick,
}) {
  const handleClick = () => {
    if (onClick) {
      onClick({ img, title, desc, link });
    }
  };

  return (
    <ProjectItemStyle onClick={handleClick}>
      <div className="project-item-img">
        <img src={img} alt={title} />
      </div>
      <div className="project-item-info">
        <h3 className="project-item-title">{title}</h3>
        <p className="project-item-desc">{desc}</p>
        {link && (
          <p className="project-link">{link}</p>
        )}
      </div>
    </ProjectItemStyle>
  );
}

export default ProjectItem;
